import styled from 'styled-components';

export const StationMapWrapper = styled.div`
  position: relative;
  height: 100%;
  min-height: 100%;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  margin: 0;
  display: flex;
  justify-content: flex-end;
  border-radius: 3px;

  & > .map-container {
    width: 100%;
    height: 100%;
  }
`;
